export class ListData {
  pageIndex!: number;
  totalCount!: number;
  pageSize!: number;
  totalCountPast!: number;
  totalCountOngoing!: number;
  userType!: string;
  pageData!: {
    announcementId: number,
    iconAnnouncement: string,
    nameAnnouncement: string,
    typeAnnouncement: string,
    dateAnnouncement: string,
    timeAnnouncementFrom: string,
    timeAnnouncementTo: string,
    branchName: string,
    howCreatedAnnouncement: number
    restaurant: Restaurant
    reservation: Reservation
  }[];
}
export class Restaurant {
  icon!: string;
  id!: number;
  nameAr!: string;
  nameEn!: string;
}

export class Reservation {
  id!: number;
  partySize!: number
  tableName!: string
  reservationNumber!: number
}
export class Record {
  announcementId!: number;
  iconAnnouncement!: string;
  nameAnnouncement!: string;
  typeAnnouncement!: string;
  dateAnnouncement!: string;
  timeAnnouncementFrom!: string;
  timeAnnouncementTo!: string;
  branchName!: string;
  howCreatedAnnouncement!: number;
}

export class ListFilter {
  pageSize!: number;
  pageNumber!: number;
  searchText!: string;
  announcementStuts!: number
  dateTo!: Date;
  dateFrom!: Date;
  timeTo!: Date;
  timeFrom!: Date;
  companionsNumber!: number;
  restaurantID!: number;
}

export enum announcementType {
  UpcomingAndOngoing = 1,
  Past = 0
}
